import {defaultNS, fallbackLanguage, nameSpaces, resources} from '>generated/locales/config';
import {setupI18n} from '>shared/lib/i18n';

export default setupI18n(resources, fallbackLanguage, nameSpaces, defaultNS);

